import { ILegalGroup } from "../models/response/legal-document/ILegalGroup";
import { apiClient } from "./apiClient";
import { apiGuestClient } from "./apiGuestClient";
export const LEGAL_GROUP_ENDPOIT = "legal-document/group";
export const legalGroupApi = {
    selectAll: () => apiGuestClient.get(`${LEGAL_GROUP_ENDPOIT}`),
    insert: (request: ILegalGroup) => apiClient.post(`${LEGAL_GROUP_ENDPOIT}`, request),
    update: (request: ILegalGroup) => apiClient.put(`${LEGAL_GROUP_ENDPOIT}`, request),
    delete: (id: number) => apiGuestClient.delete(`${LEGAL_GROUP_ENDPOIT}/${id}`),
}